import { createSlice } from "@reduxjs/toolkit";
import { updateHomeVisitOnlineStatus } from "../../reducer/homeVisitOnline/updateHomeVisitOnlineReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const updateHomeVisitOnlineSlice = createSlice({
  name: "updateHomeVisitOnline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateHomeVisitOnlineStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateHomeVisitOnlineStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || null;
      })
      .addCase(updateHomeVisitOnlineStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default updateHomeVisitOnlineSlice.reducer;
